'use strict'

const Simplex1 = require('./simplex/simplex1')
const Simplex2 = require('./simplex/simplex2')

const Perlin1 = require('./perlin/perlin1')
const Perlin2 = require('./perlin/perlin2')
const Perlin3 = require('./perlin/perlin3')
const Perlin4 = require('./perlin/perlin4')
const PerlinN = require('./perlin/perlinN')

module.exports = {
  Simplex1,
  Simplex2,
  Perlin1,
  Perlin2,
  Perlin3,
  Perlin4,
  PerlinN
}
